import { useMutation } from "@tanstack/react-query";
import { Dropdown } from "primereact/dropdown";
import { useState, useEffect } from "react";
import { DCSQueryClient } from "../../../../queryClient";
import { useToast } from "../../../../Providers/ToastProvider";
import { EmployeeRoles, EmployeeStatuses } from "../../../../models/Employee";
import { requests } from "../../../../services/http-common";

import styles from "./EmployeeStatus.module.scss";
import { classNames as cx } from "primereact/utils";
import { useUser } from "../../../../keycloak";
import { UserRoles } from "../../../../constants/userRoles";

const statusOptions = [
  { label: "Active", value: EmployeeStatuses.ACTIVE },
  {
    // label: "Terminated(Rehirable)",
      label: "Terminated",
    value: EmployeeStatuses.TERMINATED_REHIRABLE,
  },
  // { label: "Terminated", value: EmployeeStatuses.TERMINATED },
];

const type = {
  [EmployeeStatuses.ACTIVE]: "active",
  [EmployeeStatuses.TERMINATED_REHIRABLE]: "terminated-rehirable",
  [EmployeeStatuses.TERMINATED]: "terminated",
};

export const EmployeeStatus = (rowData: {
  status: EmployeeStatuses;
  id: string;
  role: EmployeeRoles;
}) => {
  const [employeeStatus, setStatus] = useState<EmployeeStatuses>(
    rowData.status
  );

  const user: any = useUser();

  const { show } = useToast();

  const updateEmpployeeStatus = useMutation({
    mutationFn: (newStatus: EmployeeStatuses) => {
      return requests.put(`/user/${rowData.id}`, { status: newStatus });
    },
    onSuccess: () => {
      show({ detail: "Status updated !" });
      DCSQueryClient.invalidateQueries({ queryKey: ["employee-list"] });
    },
    onError: (error: any) => {
      show({
        severity: "error",
        detail: error.response.data.error.message || "Something went wrong ",
      });
      setStatus(rowData.status);
    },
  });

  const onStatusChange = (e: any) => {
    setStatus(e.target.value);
    updateEmpployeeStatus.mutate(e.target.value);
  };

  useEffect(() => {
    if (rowData.status) {
      setStatus(rowData.status);
    }
  }, [rowData.status]);

  const isDisabled =
    employeeStatus === EmployeeStatuses.TERMINATED ||
    rowData.role === EmployeeRoles.SUPERADMIN ||
    !user?.roles.dcs_client.includes(UserRoles.USER_UPDATE);

  return (
    <>
      <Dropdown
        appendTo="self"
        options={statusOptions}
        onChange={onStatusChange}
        value={employeeStatus}
        style={{ width: "235px" }}
        id="status"
        className={cx(styles[type[employeeStatus]], {
          [styles.disabled]: isDisabled,
        })}
        disabled={isDisabled}
      />
    </>
  );
};
